import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

export function useGoogleSync() {
  const { token, apiFetch } = useAuth();
  const [googleStatus, setGoogleStatus] = useState(null); // null = cargando

  const checkStatus = useCallback(async () => {
    try {
      const data = await apiFetch('/google_status.php');
      setGoogleStatus(data ?? { connected: false });
    } catch {
      setGoogleStatus({ connected: false });
    }
  }, [apiFetch]);

  const connectGoogle = useCallback(() => {
    const API_BASE = process.env.REACT_APP_API_URL || '/api';
    window.location.href = `${API_BASE}/google_auth.php?token=${token}`;
  }, [token]);

  const disconnectGoogle = useCallback(async () => {
    await apiFetch('/google_disconnect.php', { method: 'POST' });
    setGoogleStatus({ connected: false });
  }, [apiFetch]);

  const pollSync = useCallback(async () => {
    if (!googleStatus?.connected) return 0;
    try {
      const data = await apiFetch('/google_poll.php');
      return data?.changes ?? 0;
    } catch {
      return 0;
    }
  }, [apiFetch, googleStatus]);

  const renewChannel = useCallback(async () => {
    if (!googleStatus?.connected) return;
    try {
      await apiFetch('/google_renew_channel.php', { method: 'POST' });
    } catch {
      // Ignorar errores de renovación
    }
  }, [apiFetch, googleStatus]);

  useEffect(() => { checkStatus(); }, [checkStatus]);

  return { googleStatus, connectGoogle, disconnectGoogle, pollSync, renewChannel, checkStatus };
}
